import { action, computed, makeObservable, observable } from 'mobx';
import { adminService } from '@sagano/admin/services';
import { Train, PhysicalTrain } from '@sagano/admin/services/types';

const storage = sessionStorage;
const TRAINS = 'trains';
const PHYSICAL_TRAINS = 'physicalTrains';

export class Trains {
  @observable accessor trains: Array<Train> = JSON.parse(
    storage.getItem(TRAINS) || '[]'
  );
  @observable accessor physicalTrains: Array<PhysicalTrain> = JSON.parse(
    storage.getItem(PHYSICAL_TRAINS) || '[]'
  );

  constructor() {
    makeObservable(this);
  }

  @action
  fetchTrains = async () => {
    if (!this.loaded) {
      return adminService.listLogicalTrains().then(res => {
        if (res?.trains) {
          try {
            storage.setItem(TRAINS, JSON.stringify(res.trains));
          } finally {
            this.setTrains(res.trains);
          }
        }
      });
    } else {
      return this.trains;
    }
  };

  @action
  setTrains = (trains: Array<Train>) => {
    this.trains = trains;
  };

  @action
  fetchPhysicalTrains = async () => {
    if (!this.physicalTrainsLoaded) {
      return adminService.listPhysicalTrains().then(res => {
        if (res?.trains) {
          try {
            storage.setItem(PHYSICAL_TRAINS, JSON.stringify(res.trains));
          } finally {
            this.setPhysicalTrains(res.trains);
          }
        }
      });
    } else {
      return this.physicalTrains;
    }
  };

  @action
  setPhysicalTrains = (trains: Array<PhysicalTrain>) => {
    this.physicalTrains = trains;
  };

  @action
  getTrainByLogicalTrainId = (logicalTrainId: string) => {
    return this.trains.find(train => train.logicalTrainId === logicalTrainId);
  };

  @computed
  get trainsList() {
    return this.trains.map(train => ({
      logicalTrainId: train.logicalTrainId,
      name: train.name,
      physicalTrainId: train.physicalTrainId
    }));
  }

  @computed
  get loaded() {
    return this.trains.length > 0;
  }

  @computed
  get physicalTrainsLoaded() {
    return this.physicalTrains.length > 0;
  }
}

export default new Trains();
